<div class="card">
  <span class="material-symbols-rounded draft">draft</span>
  <div class="text-div">
    <p class="file-name">{{ convertedFileName }}</p>
    <p class="file-size">{{ fileSize.toFixed(2) }}KB</p>
  </div>
  <div class="text-div">
    <p class="file-name">{{ fileName }}</p>
  </div>
  <p class="status">
    {{ "convertedFileCard.jobStatus.0" | translate }}
  </p>
  <button (click)="downloadConvertedFile()">
    <p class="material-symbols-rounded download">download</p>
  </button>
  <button (click)="deleteConvertedFile()">
    <span class="material-symbols-rounded cancel">delete</span>
  </button>
</div>
